<template>
  <section class="video-recording w mx-auto">
    <div class="text-center content-title">
      <span class="inline-block line-css"></span>
      <span class="font-css"> <span>视频记录片</span> VIDEO DOCUMENTARY </span>
      <span class="inline-block line-css"></span>
    </div>
    <div class="fp-content w-full text-center clearfix">
      <div class="fp-content-video float-left w-2/3 relative clearfix">
        <VideoPlayer
          class="video"
          v-if="videoData"
          :data="videoData"
          :autoplay="videoAutoplay"
          type="video"
        ></VideoPlayer>
      </div>
      <swiper
        v-if="videos && videos.length !== 0"
        class="fp-content-thumbnails float-left w-1/3 clearfix"
        :options="hooperSettings"
      >
        <swiper-slide
          v-for="video in videos"
          :key="video.id"
          :data-id="video.id"
          class="video-silde"
        >
          <div
            class="fp-content-thumbnail-img cursor-pointer"
            :style="'background-image:url(' + video.thumbnail_url + ');'"
          ></div>
          <!-- <div
            class="fp-content-thumbnail-name absolute cursor-pointer clearfix overflow-hidden text-left"
            @click="
              link({
                type: 'info',
                category: video.category_id,
                id: video.id
              })
            "
          >
            {{ video.title }}
          </div> -->
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <div
        v-else
        class="fp-content-thumbnails clearfix text-center no-data float-right"
      >
        暂无数据
      </div>
    </div>
  </section>
</template>

<script>
import link from '@/core/mixins/link'
import VideoPlayer from '@/components/common/Video'
import { getVideos } from '@/core/api'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'videos-component',
  props: {},
  mixins: [link],
  components: { VideoPlayer, swiper, swiperSlide },
  data() {
    return {
      hooperSettings: {
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      play: true,
      videos: [],
      videoData: null,
      // videoPlayTitle: null,
      videoAutoplay: false
    }
  },
  computed: {
    carousels() {
      let data = this.$store.getters['CarouselsStore/carousels']
      if (data === false) {
        return false
      }
      return data
    }
  },
  mounted: function() {
    this.getVideos()
  },
  methods: {
    async getVideos() {
      // 获取 视频列表信息
      let res = await getVideos('video', {})
      if (res.status === 200) {
        this.videos = res.data.data
        this.videoPlay(res.data.data[0])
        this.videoAutoplay = false

        // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----begin-----
        let _this = this
        this.$nextTick(() => {
          var videoSlides = document.querySelectorAll('.video-silde')
          videoSlides.forEach(item => {
            item.onclick = function() {
              let res = _this.videos.filter(v => v.id + '' === item.dataset.id)
              if (res && res.length) _this.videoPlay(res[0])
            }
          })
        })
        // swiper loop:true时，复制的dom绑定不上事件，现用js绑定-----end-----
      }
    },
    videoPlay(video) {
      this.$set(this, 'videoData', video)
      this.$set(this, 'videoAutoplay', true)
      // this.videoPlayTitle = video.title
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.video-recording {
  .fp-content {
    height: 500px;
  }
  .fp-content-video,
  .fp-content-thumbnails {
    display: inline-block;
    height: 100%;
    background-color: $c-transparent-8;
  }

  .fp-content-video {
    .video {
      width: 100%;
      height: 100%;
    }
  }
  .fp-content-thumbnails {
    width: 33.33%;
  }
  .fp-content-thumbnail-img {
    width: 100%;
    height: 168px;
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
  }
  ::v-deep  .vjs-poster {
    background-size: 100% auto;
  }
  // .fp-content-thumbnail-name {
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   opacity: 0;
  //   height: 36px;
  //   padding: 0 20px;
  //   line-height: 36px;
  //   font-size: 14px;
  //   color: $c-white;
  //   -o-text-overflow: ellipsis; /* Opera 9-10 */
  //   text-overflow: ellipsis;
  //   white-space: nowrap;
  //   background-color: $c-transparent-6;
  // }
  .fp-content-thumbnail-play {
    position: absolute;
    bottom: 60px;
    left: 12px;
  }
  // ::v-deep  .swiper-slide {
  //   position: relative;
  //   &:hover {
  //     .fp-content-thumbnail-name {
  //       transition: all 0.35s;
  //       -moz-transition: all 0.35s;
  //       -webkit-transition: all 0.35s;
  //       -o-transition: all 0.35s;
  //       opacity: 1;
  //     }
  //   }
  // }
  ::v-deep  .swiper-button-prev,
  ::v-deep  .swiper-button-next {
    right: 50%;
    margin-right: -28px;
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 24px 24px;
    width: 56px;
    height: 56px;
    left: auto;
  }
  ::v-deep  .swiper-button-prev {
    top: 22px;
    background-image: url('../../../static/images/public/arrow-up.png');
  }
  ::v-deep  .swiper-button-next {
    bottom: 0;
    top: auto;
    background-image: url('../../../static/images/public/arrow-down.png');
  }
}
</style>
